var container = $('.rca-form');

var switchFormItems = function switchFormItems() {
    var itemsShow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var itemsHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    for (var i = 0; i < itemsShow.length; i++) {
        container.find('[name="' + itemsShow[i] + '"]').attr('data-csr', '').closest('.form-group').show();
    }

    for (var _i = 0; _i < itemsHide.length; _i++) {
        container.find('[name="' + itemsHide[_i] + '"]').removeAttr('data-csr', '').closest('.form-group').hide();
    }
};

var setIdType = function setIdType(value) {
    var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    container.find('[data-owner-id-type]').removeClass('selected');
    container.find('[data-owner-id-type="' + value + '"]').addClass('selected');
    var ciFields = ['owner_seriebi', 'owner_numberbi'];
    var passportFields = ['owner_nrPassport'];

    if ('ci' == value) {
        switchFormItems(ciFields, passportFields);
    } else {
        switchFormItems(passportFields, ciFields);
    }

    if (update) {
        container.find('[name="owner_id_type"]').val(value);
    }
};

var setPersonType = function setPersonType(value) {
    container.find('[data-owner-type]').removeClass('selected');
    container.find('[data-owner-type="' + value + '"]').addClass('selected');
    var companyFields = ['companyName', 'cif', 'owner_pj_telefon', 'owner_activitate'];
    var pfFields = ['owner_fname', 'owner_lname', 'owner_CNP', 'owner_dlicense', 'owner_telefon', 'owner_seriebi', 'owner_numberbi', 'owner_nrPassport', 'owner_dlicense'];

    if ('fizica' == value) {
        switchFormItems(pfFields, companyFields);
        container.find('#owner-id-type-selector').show();
        setIdType(container.find('[name="owner_id_type"]').val(), false);
    } else {
        switchFormItems(companyFields, pfFields);
        container.find('#owner-id-type-selector').hide();
    }

    container.find('[name="person_type"]').val(value);
};

var handleTrailers = function (val) {
    var excluded = ["37", "38", "39"];
    if (val) {
        if (excluded.includes(val)) {
            container.find('[id="csr_capacitate_cilindrica"]').removeAttr('data-csr').closest('.form-group').hide();
            container.find('[id="csr_putere"]').removeAttr('data-csr').closest('.form-group').hide();
            container.find('[id="csr_numar_locuri"]').removeAttr('data-csr').closest('.form-group').hide();
        } else {
            container.find('[id="csr_capacitate_cilindrica"]').attr('data-csr', '').closest('.form-group').show();
            container.find('[id="csr_putere"]').attr('data-csr', '').closest('.form-group').show();
            container.find('[id="csr_numar_locuri"]').attr('data-csr', '').closest('.form-group').show();
            handleElectric($('#csr_fuelType').val());
        }
    }
}

let handleElectric = function (val) {
    let excluded = ['Electric'];
    if(excluded.includes(val)) {
        container.find('[id="csr_capacitate_cilindrica"]').val('');
        container.find('[id="csr_capacitate_cilindrica"]').removeAttr('data-csr').closest('.form-group').hide();
    } else {
        container.find('[id="csr_capacitate_cilindrica"]').attr('data-csr', '').closest('.form-group').show();
    }
}

var setLeasing = function setLeasing(value) {
    var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    value = 'true' == value ? true : false;
    container.find('[data-leasing]').removeClass('selected');
    container.find('[data-leasing="' + value + '"]').addClass('selected');

    if (update) {
        container.find('[name="leasing"]').val(value);
    }

    var fields = ['leasingCompanyName', 'leasingCif', 'leasing_state_id', 'leasing_locality', 'leasing_street', 'leasing_cod_postal'];
    var wrapper = container.find('#leasing-selector');

    if (value) {
        switchFormItems(fields, []);
        wrapper.show();
    } else {
        switchFormItems([], fields);
        wrapper.hide();
    }
};

var periodSetup = function periodSetup(container) {
    var format = 'YYYY-MM-DD';

    var change = function change() {
        var _p = $(picker).data('datepicker');

        if ('undefined' != typeof _p) {
            var start = new moment(_p.dates[0]);
            var months = container.find('#csr_durata').val();

            if (months) {
                var end = start.clone().add(months, 'months').subtract(1, 'days');
                $(container).find('#start-date').html(start.format(format));
                $(container).find('#end-date').html(end.format(format)); // console.log( $(container).find('#selected_date'),start.format(format) )

                $(container).find('#csr_selected_date').val(start.format(format));
            }
        }
    };

    var dp = function dp(container) {
        var now = moment();
        var min = now.add(1, 'day');
        var max = min.clone().add(59, 'day');
        var dp = container.datepicker({
            leftArrow: '<i class="fa fa-long-arrow-left"></i>',
            rightArrow: '<i class="fa fa-long-arrow-right"></i>',
            startDate: min.toDate(),
            date: min.toDate(),
            endDate: max.toDate()
        });
        var nd = min;
        var value = container.attr('data-value');

        if (value) {
            nd = new moment(value, format);
        }

        $(dp).datepicker("update", nd.toDate());
        change();
        dp.on('changeDate', function (e) {
            change();
        });
        return dp;
    };

    var period = container.find('#csr_durata');
    var picker = dp($('#selected_date_calendar'));

    if (!period.val()) {
        picker.hide();
        container.find('.if-calendar').hide();
    }

    period.bind('change', function (e) {
        var val = $(e.target).val();

        if (!val) {
            container.find('.if-calendar').hide();
            picker.hide();
        } else {
            picker.show();
            container.find('.if-calendar').show();
            change();
        }
    });
    change();
};

var drpcivApply = function drpcivApply(val) {
    var url = '/csr/utility/vin?vin=' + val;
    axios.get(url).then(function (response) {
        if ('undefined' != typeof response.data.serie_sasiu) {
            let data = response.data;
            container.find('[name="putere"]').val(data.putere);
            container.find('[name="fuelType"]').find('option').each(function () {
                if ($(this).val() === data.combustibil) {
                    $(this).attr("selected", "selected");
                }
            });

            window.localStorage.setItem('trans-subcategory', data.mapare_categorii[0].mapare_subcategorii[1]);
            window.localStorage.setItem('trans-marca', data.marca);

            container.find('[name="categorie"]').find('option').each(function () {
                if ($(this).val() == data.mapare_categorii[0].mapare_subcategorii[0]) {
                    $(this).attr("selected", "selected");
                    $(this).parent()[0].dispatchEvent(new Event('change'));

                    setTimeout(function () {
                        container.find('[name="subcategorie"]').find('option').each(function () {
                            if ($(this).val() == data.mapare_categorii[0].mapare_subcategorii[1]) {
                                $(this).attr("selected", "selected");
                                $(this).parent()[0].dispatchEvent(new Event('change'));

                                setTimeout(function () {

                                    container.find('[name="marca"]').find('option').each(function () {
                                        if ($(this).val() === data.marca) {
                                            $(this).attr("selected", "selected");
                                        }
                                    });
                                }, 1000);
                            }
                        });
                    }, 1000);
                }
            });
            container.find('[name="fuelType"]').find('[value="' + data.fuelType + '"]').attr("selected", "selected");
            container.find('[name="an_fabricatie"]').val(data.an_fabricatie);
            container.find('[name="masa_maxima"]').val(data.masa_maxima);
            container.find('[name="registrationNumber"]').val(data.registrationNumber);
            container.find('[name="seriaCIV"]').val(data.seriaCIV);
            container.find('[name="numar_locuri"]').val(data.numar_locuri);
            container.find('[name="model"]').val(data.model_varianta);
            container.find('[name="capacitate_cilindrica"]').val(data.capacitate_cilindrica);
        }
    });
};

var showQuoteError = function showQuoteError(container, error) {
    // $(container).find('.csr-ip-error-message:first').html(error);
    $(container).find('.csr-ip-error-message:first').attr('title', error);
    $(container).find('.csr-ip-error').removeClass('d-none');
    $(container).find('.csr-quotation-error-td').removeClass('d-none');

    $(container).removeClass('d-none');
}

var providerQuote = function providerQuote(container) {
    return new Promise((resolve, reject) => {
        var name = $(container).attr('data-csr-insurance-provider');

        var url = '/csr/quotation/' + name;
        axios.get(url).then(function (response) {
            var info = response.data;

            $(container).find('.csr-ip-logo:first').attr('src', info.logo);
            $(container).find('.csr-ip-logo:first').removeClass('d-none');

            if (info.with.error) {
                showQuoteError(container, info.with.message);
                resolve(name, ":", info.with.message);
            } else if (info.without.error) {
                showQuoteError(container, info.without.message);
                resolve(name, ":", info.without.message);
            } else {
                $(container).find('.csr-ip-no-decont:first').html(new Intl.NumberFormat('de-DE').format(info.without.prima) + ' RON');
                $(container).find('.csr-ip-no-decont-net:first').html(info.without.prima_neta + ' RON');
                $(container).find('.csr-ip-no-decont-ref:first').html(info.without.tarif_referinta + ' RON');
                $(container).find('.csr-ip-decont:first').html(new Intl.NumberFormat('de-DE').format(info["with"].prima) + ' RON');
                $(container).find('.csr-ip-decont-net:first').html(info.without.prima_neta + ' RON');
                $(container).find('.csr-ip-decont-ref:first').html(info.without.tarif_referinta + ' RON');
                $(container).find('.csr-ip-class:first').html(info["with"].clasa_bm);
                $(container).find('.csr-ip-excluded:first').html(info["with"].excluderi_carte_verde);
                $(container).find('.csr-comision-with:first').html(parseFloat(info["with"].comision_procent));
                $(container).find('.csr-comision-valoare-with:first').html(parseFloat(info["with"].comision_valoare));
                $(container).find('.csr-comision-without:first').html(parseFloat(info.without.comision_procent));
                $(container).find('.csr-comision-valoare-without:first').html(parseFloat(info.without.comision_valoare));

                $(container).find('.csr-button-td').removeClass('d-none');
                $(container).find('.csr-ip-info').removeClass('d-none');
                $(container).find('.csr-ip-logo:first').removeClass('d-none');
                $(container).removeClass('d-none');

                sortTable();
                resolve();
            }
        })["catch"](function (error) {
            console.log(error);
            reject(error);
        });
    })
};

function setTableClickHandlers() {
    $('.rca-offer').find('.csr-ip-btn-offer').on('click', function (e) {
        var btn = $(e.target);

        var params = {
            decont: 1 == btn.closest('.csr-ip-button-wrapper').find('.csr-ip-decont').length,
            societate: btn.closest('tr').attr('data-csr-insurance-provider')
        };
        var form = document.createElement('form');
        form.method = 'GET';
        form.action = '/asigurari-rca/order';

        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                var hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = params[key];
                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();

        $('.csr-ip-btn-offer').attr("disabled", "disabled");
        $('.csr-ip-btn-offer').css({
            "opacity": ".2",
            "cursor": "progress"
        });
        $('.csr-ip-btn-offer').text("Se încarcă");

    });
}

function sortTable() {
    var offers = document.querySelectorAll('.rca-tr')
    var position_arr = [];
    for (var i = 0; i < offers.length; i++) {
        position_arr.push(i);
    }

    var swapped = true;
    while (swapped === true) {
        swapped = false;
        for (var j = 0; j < offers.length - 1; j++) {
            var j_value = parseFloat(offers[position_arr[j]].children[1].children[0].children[0].innerText.split(' ')[0])
            var next_value = parseFloat(offers[position_arr[j + 1]].children[1].children[0].children[0].innerText.split(' ')[0])

            if (isNaN(j_value)) j_value = Infinity;
            if (isNaN(next_value)) next_value = Infinity;

            if (j_value > next_value) { //change
                swapped = true;
                var temp = position_arr[j];
                position_arr[j] = position_arr[j + 1]
                position_arr[j + 1] = temp
            }
        }
    }
    $('.rca-tr').remove();
    var loader = document.getElementById('cotations-loading-animation');
    loader.remove();

    for (var i = 0; i < offers.length; i++) {
        document.getElementById('rca-table').children[0].appendChild(offers[position_arr[i]]);
    }
    document.getElementById('rca-table').children[0].appendChild(loader);

    setTableClickHandlers();
}

var enforceRegisteredCar = function enforceRegisteredCar(status) {
    var withModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var btn = $('#next_step');

    if (status) {
        btn.removeAttr('disabled');
    } else {
        btn.attr('disabled', 'disabled');

        if (withModal) {
            $('#registration_required_modal').modal('show');
        }
    }
};
var toggleBrandsWarning = function (container) {
    let items = container.find('[name="marca"]').find('option').length;
    console.log(items);
    if (container.find('[name="marca"]').find('option').length > 1) {
        $('.brand-warning').addClass('d-none')
    } else {
        $('.brand-warning').removeClass('d-none')
    }
}

$(document).ready(function () {
    var container = $('.rca-form');
    setPersonType(container.find('[name="person_type"]').val(), false);
    container.find('[data-owner-type]').bind('click', function (e) {
        setPersonType($(e.target).attr('data-owner-type'));
    });

    setLeasing(container.find('[name="leasing"]').val(), false);
    container.find('[data-leasing]').bind('click', function (e) {
        setLeasing($(e.target).attr('data-leasing'));
    });
    setIdType(container.find('[name="owner_id_type"]').val(), false);
    container.find('[data-owner-id-type]').bind('click', function (e) {
        setIdType($(e.target).attr('data-owner-id-type'));
    });

    let subcategoryInput = $('#csr_subcategorie');
    handleTrailers(subcategoryInput.val());
    subcategoryInput.bind('change', function (e) {
        handleTrailers($(this).val());
    })

    $('#csr_fuelType').bind('change', function () {
        handleElectric($(this).val());
    })
    handleElectric($('#csr_fuelType').val());

    periodSetup(container);
    var providers = $('[data-csr-insurance-provider]');


    var promiseList = [];
    for (var i = 0; i < providers.length; i++) {
        var provider = providers[i];
        promiseList.push(providerQuote(provider));
    }
    Promise.all(promiseList)
        .then(results => {
            document.getElementById('cotations-loading-animation').hidden = true;
            console.log("All cotations loaded.");
            for (var result of results) {
                if (result) console.log(result);
            }
        })
        .catch(err => {
            console.log(err);
        })

    container.find('[data-owner-type]').bind('click', function (e) {
        setPersonType($(e.target).attr('data-owner-type'));
    });
    container.find('[name="serie_sasiu"]').bind('blur', function (e) {
        drpcivApply($(e.target).val());
    });
    var registrationStatus = container.find('[name="tip_inmatriculare"]');
    var tipUtilizare = container.find('[name="masina_tip_utilizare"]');

    if (registrationStatus.length > 0) {
        if (registrationStatus.val() !== '') {
            enforceRegisteredCar(registrationStatus.val() === 'inmatriculat');
        }
    }

    registrationStatus.bind('change', function (e) {
        if (registrationStatus.val() === 'inmatriculat') {
            var withModal = false;
        } else {
            var withModal = true;
        }

        enforceRegisteredCar(registrationStatus.val() === 'inmatriculat' && tipUtilizare.val() !== "", withModal);
    });
    tipUtilizare.bind('change', function (e) {
        enforceRegisteredCar(tipUtilizare.val() !== "" && registrationStatus.val() === 'inmatriculat', false);
    });
    tipUtilizare.trigger('change');

    container.find('[name="marca"]').on("filled", function (e) {
        if ($(e.target).find('option').length > 1) {
            $('.brand-warning').addClass('d-none')
        } else {
            $('.brand-warning').removeClass('d-none')
        }
    })
});
